import { render, staticRenderFns } from "./InputInVModel.vue?vue&type=template&id=226be3fc&"
import script from "./InputInVModel.vue?vue&type=script&lang=js&"
export * from "./InputInVModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports